// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.defaultRoot {
    color: #eceff8;
    overflow-x: auto;
    overflow-y: auto;
    height: 90lvh;
    width: 100%;   
}

.dasha-textarea {
    width: 100%;
    background: rgba(0,0,0,0);
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/DiagnosticsPanel/styles.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;AAChB","sourcesContent":[".defaultRoot {\n    color: #eceff8;\n    overflow-x: auto;\n    overflow-y: auto;\n    height: 90lvh;\n    width: 100%;   \n}\n\n.dasha-textarea {\n    width: 100%;\n    background: rgba(0,0,0,0);\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
